/**
 * useEmbedAuth — vendor binding of the shared embed-auth hook.
 *
 * The exchange/persistence logic lives in @semo/shared-utils so the vendor and
 * buyer embed entry points stay in lockstep; the only app-specific piece is the
 * Supabase client singleton, injected here.
 */

import {
  useEmbedAuth as useSharedEmbedAuth,
  type EmbedAuthState,
  type UseEmbedAuthOptions as SharedUseEmbedAuthOptions,
} from "@semo/shared-utils";
import { setSupabaseAuth } from "../../../../lib/supabase";

export { __resetEmbedTokenExchangeForTests } from "@semo/shared-utils";
export type { EmbedAuthState };

export type UseEmbedAuthOptions = Omit<
  SharedUseEmbedAuthOptions,
  "setSupabaseAuth"
>;

export function useEmbedAuth(
  options: UseEmbedAuthOptions = {},
): EmbedAuthState {
  return useSharedEmbedAuth({ ...options, setSupabaseAuth });
}
